import Splide from '@splidejs/splide';

const Clients = {};

export default Clients

const cSlider = document.querySelectorAll('.clients__slider');

if (cSlider) {
    cSlider.forEach((slider)=>{
        new Splide( slider, {
            type: 	'loop',
            rewind: true,
            perPage: 8,
            perMove: 1,
            autoplay: true,
            interval: 3000,
            pauseOnHover: true,
            breakpoints: {
                768: {
                    perPage: 2,
                    pagination: true
                }
            }
        } ).mount();
    });
}